export const addInvoiceObj = {
  "asset": null,
  "from": null,
  "to": null,
  "invoice_number": "",
  "invoice_division":"",
  "invoice_type": {
    "value": 9,
    "label": "Adhoc"
  },
  "date": null,
  "due_date": null,
  "currency": "",
  "remarks": "",
  "bank": null,
  "invoice_items": []
}

export const invoiceTypes = [{ label: 'Ad Hoc Invoice', value: 9 },{ label: 'Debit Note Invoice', value: 4 }, { label: 'Credit Note Invoice', value: 5 }]

export const getSignedTaxPercentage = (item) => {
  const percentage = parseFloat(item?.tax_percentage ? item?.tax_percentage : item?.percentage) || 0;
  return item?.type?.value === 2 ? -percentage : percentage;
};

export const getSignedTaxAmount = (item, amountKey = 'tax_amount') => {
  const amount = Math.abs(parseFloat(item?.[amountKey]) || 0);
  return item?.type?.value === 2 ? -amount : amount;
};

export const getAdditionalTax =(itemArr, taxArr)=>{
  if (!Array.isArray(itemArr) || !Array.isArray(taxArr)) return itemArr || [];
  let filterTax = taxArr.filter(i => i?.is_included_in_funds)
  let totalTax = parseFloat(filterTax.map(i=> getSignedTaxPercentage(i)).reduce((i,next)=> i + next, 0))
  return(
    itemArr.map(item=> ({...item,
      sub_amount_total: item?.sub_amount_total? parseFloat((parseFloat(item?.sub_amount_total) + parseFloat(item?.sub_total) * totalTax / 100).toFixed(2)): item?.sub_total,
      // sub_total: item?.sub_total? parseFloat((parseFloat(item?.sub_total) + parseFloat(item?.sub_total) * totalTax / 100).toFixed(2)): item?.sub_total,
      tax_details:filterTax.map(i=> {return {additional_tax_id: i?.id, tax_amount: parseFloat((parseFloat(item?.sub_total) * parseFloat(i?.tax_percentage)) / 100).toFixed(2) }})
    }))
  )
}
export const getTotalTax = (itemArr, taxArr) => {
  if (!Array.isArray(itemArr) || !Array.isArray(taxArr)) return [];
  let filterTax = taxArr.filter(i => i?.is_included_in_funds == false);
  return filterTax.map(tax => ({
    additional_tax_id: tax?.id,
    tax_amount: parseFloat(
      itemArr.reduce((sum, item) => sum + (parseFloat(item?.sub_total) || 0) * (parseFloat(tax?.tax_percentage) || 0) / 100, 0)
    ).toFixed(2)
  }));
}

const MANAGEMENT_FEE_INVOICE_TYPE = 10;
const SENT_INVOICE_STATUS = 2;
export const DRAFT_INVOICE_STATUS = 1;

export const canDeleteInvoiceItem = (item) => {
  if (item?.is_settle === true) return false;
  if (item?.management_fee_invoice?.slug) return false;
  return true;
}

export const getInvoiceDeleteBlockedReason = (item) => {
  if (item?.management_fee_invoice?.slug) return 'This invoice is linked with a Management Fee Invoice and cannot be deleted.';
  if (item?.is_settle === true) return 'This invoice is settled and cannot be deleted.';
  return null;
}

export const getManagementFeeSelectDisabledReason = (item, selectedInvoices) => {
  if (item?.status?.value !== SENT_INVOICE_STATUS) return null;
  if (selectedInvoices.some(inv => inv.slug === item.slug)) return null;

  const isManagementFee = item?.invoice_type?.value === MANAGEMENT_FEE_INVOICE_TYPE;
  const selectedSentInvoices = selectedInvoices.filter(inv => inv?.status?.value === SENT_INVOICE_STATUS);
  const isBlocked = isManagementFee
    ? selectedSentInvoices.some(inv => inv?.invoice_type?.value !== MANAGEMENT_FEE_INVOICE_TYPE)
    : selectedSentInvoices.some(inv => inv?.invoice_type?.value === MANAGEMENT_FEE_INVOICE_TYPE);
  if (!isBlocked) return null;

  return isManagementFee
    ? 'A different invoice type is already selected. Deselect it to select a Management Fee invoice.'
    : 'A Management Fee invoice is already selected. Deselect it to select other invoice types.';
}